export default __webpack_public_path__ + "static/media/0xcd86152047e800d67bdf00a4c635a8b6c0e5c4c2.4d301e0b.webp";